import { CadObjectStatus } from '@/api/CadObjects/types';
import { statusValueLabelMap } from './statusValueLabelMap';

export const statusOptionsList: { value: CadObjectStatus; label: string }[] = Array.from(
  statusValueLabelMap.entries(),
).map(([value, label]) => ({ value, label }));
